import { useTgAuth } from '@shared/lib/useTgAuth'
import { getDayJs } from '@shared/lib/utils'
import { NotchLoader } from '@shared/ui/loader'
import { FullCenterContent } from '@shared/ui/wrappers'

//
//

const dayjs = getDayJs()

//
//

const createComponent = (WrappedComp) => () => {
  const auth = useTgAuth()

  //
  //

  if (auth.errorStatus === 401) {
    return (
      <FullCenterContent>
        <div className="text-center">Please start the app from Telegram.</div>
      </FullCenterContent>
    )
  }

  if (!auth.status) {
    return (
      <FullCenterContent>
        <NotchLoader />
      </FullCenterContent>
    )
  }

  if (auth.data.user.paused) {
    return (
      <FullCenterContent>
        <div className="text-center">
          <div>Ваш аккаунт приостановлен.</div>
          {!auth.data.user.paused.until ? (
            <div className="mt-2">
              {auth.data.user.paused.reason === 'bot_stopped' ? (
                <>Для восстановления доступа запустите бота в Telegram.</>
              ) : (
                <>Свяжитесь с поддержкой для восстановления доступа.</>
              )}
            </div>
          ) : (
            <div className="mt-2">
              Ваш аккаунт приостановлен до{' '}
              {dayjs(auth.data.user.paused.until).format('DD.MM.YYYY HH:mm')}.
            </div>
          )}
        </div>
      </FullCenterContent>
    )
  }

  return <WrappedComp />
}

//

const Wrapper = (WrappedComp) => {
  const Component = createComponent(WrappedComp)

  // eslint-disable-next-line react-hooks/static-components
  return <Component />
}

export const withAuth = (component) => () => Wrapper(component)
